import { createService } from '@betty/toolkit/api';
import { DepositSettingsSchema } from './DepositService.schemas';

export default createService(
  {
    getSettings: {
      method: 'GET',
      url: '/settings/deposit',
      responseSchema: DepositSettingsSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
